import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

axios.defaults.baseURL = apiBaseUrl;

// Helper to set auth token
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    console.log('axios: Auth token set', `Bearer ${token.substring(0, 15)}...`);
  } else {
    delete axios.defaults.headers.common['Authorization'];
    console.log('axios: Auth token removed');
  }
};

// Add request interceptor for debugging
axios.interceptors.request.use(request => {
  console.log('Request:', {
    url: request.url,
    method: request.method,
    headers: request.headers,
    data: request.data
  });
  return request;
});

// Add response interceptor for debugging
axios.interceptors.response.use(
  response => {
    console.log('Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  error => {
    console.error('Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export default axios;
